export class HeaderFooterRow{
    public rowIndex!:number;
    public type?:string; //csv or fl
    public fieldDelimiter?:string; // csv: single character delimiter
    public rowComponents!: HeaderFooterRowComponent[];

    constructor(){
        this.rowComponents=[];
    }
}

export class HeaderFooterRowComponent{
    public name?:string;
    public index?:number;
    public type?:number; //1=DateTime, 2=Unique Id, 3=Text, 4=Data, 5=Variable, 6=Metadata
    public value?:string;
    public fieldLength?:number; //for fixed length format
    public paddingDirection?:string; //l for left, r for right. if omitted: default is right
    public paddingCharacter?:string; //if omitted: default is blank
}